// extracted by mini-css-extract-plugin
export default {"footerContainer":"UpdatePlanModal_footerContainer__yBx0x","separator":"UpdatePlanModal_separator__Q9maF","body":"UpdatePlanModal_body__tlGtk"};